import { Formik } from 'formik';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, Label } from 'reactstrap';
import { Alert, Button, Dropdown, Input } from '../../../../UI/Common';
import DatePicker from 'react-datepicker';
import Required from '../../../../UI/Required';
import validationSchema from './processValidationSchema';
import Datagrid from '../../../../UI/Datagrid';

function ProcessForm({
  t,
  values,
  containsNames,
  additionalField,
  prefix,
  index,
  handleChange,
  setFieldValue,
  touched,
  errors,
  ...props
}) {
  const columns = [{ dataField: 'name', text: 'Group', sort: true }];
  const defaultSorted = [{ dataField: 'name', order: 'asc' }];
  const [groupIds, setGroupIds] = React.useState([]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setGroupIds([...groupIds, row.id]);
    } else {
      setGroupIds(groupIds.filter((x) => x !== row.id));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      setGroupIds(ids);
    } else {
      setGroupIds([]);
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: groupIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  React.useEffect(() => {
    setFieldValue(`processes.${index}.groupIds`, groupIds);
  }, [groupIds]);
  let timeFormat = 'HH:mm';
  if (props.i18n.language === 'en_US') {
    timeFormat = 'h:mm aa';
  }
  return (
    <div className="d-flex">
      <div className="w-50">
        <Input
          required
          id={`processes.${index}.process`}
          label="Process Name"
          onChange={handleChange(`processes.${index}.process`)}
          value={values.process}
          invalid={
            touched[prefix] &&
            touched[prefix][index] &&
            touched[prefix][index].process
          }
          error={
            errors[prefix] &&
            errors[prefix][index] &&
            errors[prefix][index].process
          }
        />
        <div>
          <FormGroup className="d-inline-block mr-2">
            <Label>
              {t('Beginning')} <Required />
            </Label>
            <DatePicker
              id={`processes.${index}.beginTime`}
              autoComplete="off"
              className="form-control"
              selected={values.beginTime}
              onChange={(date) =>
                setFieldValue(`processes.${index}.beginTime`, date)
              }
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat={`MM/dd/yyyy ${timeFormat}`}
            />
          </FormGroup>
          <FormGroup className="d-inline-block">
            <Label>
              {t('Ending')} <Required />
            </Label>
            <DatePicker
              id={`processes.${index}.endTime`}
              autoComplete="off"
              className="form-control"
              selected={values.endTime}
              onChange={(date) =>
                setFieldValue(`processes.${index}.endTime`, date)
              }
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat={`MM/dd/yyyy ${timeFormat}`}
            />
          </FormGroup>
        </div>
        {containsNames ? (
          <Dropdown
            id={`processes.${index}.filler`}
            label="Filler"
            data={props.users || []}
            onChange={({ value, text }) => {
              setFieldValue(`processes.${index}.filler`, value);
              setFieldValue(`processes.${index}.additional`, text);
            }}
            value={values.filler}
            valueKey="id"
            nameKey="userName"
            invalid={
              touched[prefix] &&
              touched[prefix][index] &&
              touched[prefix][index].filler
            }
            error={
              errors[prefix] &&
              errors[prefix][index] &&
              errors[prefix][index].filler
            }
          />
        ) : (
          <Input
            id={`processes.${index}.additional`}
            label={additionalField}
            onChange={handleChange(`processes.${index}.additional`)}
            value={values.additional}
            invalid={
              touched[prefix] &&
              touched[prefix][index] &&
              touched[prefix][index].additional
            }
            error={
              errors[prefix] &&
              errors[prefix][index] &&
              errors[prefix][index].additional
            }
          />
        )}
        <Datagrid
          datagridProps={{
            keyField: 'id',
            data: props.groups,
            loading: props.fetchingGroups,
            defaultSorted,
            columns,
            selectRow,
          }}
          noSearch
          noPagination
          noExport
        />
      </div>
      <div className="d-flex flex-1 justify-content-end">
        <a
          style={{ height: 'fit-content' }}
          onClick={() => props.remove(index)}
          className="abutton"
        >
          Remove
        </a>
      </div>
      {/* <Alert.Error text={props.errors} /> */}
    </div>
  );
}

export default withTranslation('app')(ProcessForm);
